








































































































































































import Vue from 'vue';
import { CloseFullscreenWrapper, FormValidation } from '@/mixins';
import { OpenForgotUsernameScreen } from '@/mixins/get-content-mixins';

import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';

import { api, MEMBER_API_SUB_URLS } from '@/api';

import { required, sameAs } from 'vuelidate/lib/validators';

import { lengthRange, password } from '@/validations';
import { ExtendMixins } from '@/services';
import { ForgotPasswordFormModel } from '@/@types/member';
import PasswordValidationIcon from './registration/password-status.component.vue';

interface Data {
  isLoading: boolean;
  confirmBeforeClose: boolean;
  showSuccessMessage: boolean;
  showErrorMessage: boolean;
  formValid: boolean;
  loadingMessage: string;
  formUsernameValid: boolean;
  errorMessage: string;
  successMessage: string;
  tokenSent: boolean;
  formModel: ForgotPasswordFormModel;
  isPasswordVisible: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  OpenForgotUsernameScreen,
).extend({
  name: 'ForgotUsername',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  beforeMount() {
    this.constructShowErrorModel('formModel');
  },
  data(): Data {
    return {
      isLoading: false,
      confirmBeforeClose: true,
      showSuccessMessage: false,
      showErrorMessage: false,
      formValid: false,
      loadingMessage: this.$options.filters.t([
        'global_finding-data',
        'global_loading',
      ]),
      formUsernameValid: false,
      errorMessage: this.params.errorMessage,
      successMessage: this.params.successMessage,
      tokenSent: false,
      formModel: {
        passwordModel: {
          password: '',
          passwordConfirm: '',
          token: '',
        },
        usernameModel: {
          userName: '',
        },
      },
      isPasswordVisible: false,
    };
  },
  validations: {
    formModel: {
      passwordModel: {
        token: {
          required,
        },
        password: {
          lengthRange: lengthRange(15, 256),
          pwFirstChar: password.firstChar,
          pwValidChars: password.validChars,
          pwRepeatingChars: password.repeatingChars,
          pwAlphaNumericChars: password.alphaNumeric,
          pwSpecialChar: password.specialChar,
          pwUpperLower: password.upperLower,
          required,
        },
        passwordConfirm: {
          required,
          sameAs: sameAs('password'),
        },
      },
      usernameModel: {
        userName: {
          required,
          lengthRange: lengthRange(6, 14),
        },
      },
    },
  },
  computed: {
    // VALIDATION MESSAGES
    tokenErrors(): string[] {
      const formField = 'formModel.passwordModel.token';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'global_form-error_token_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    userNameErrors(): string[] {
      const formField = 'formModel.usernameModel.userName';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'register_form-error_username_required',
            'global_form-error_username_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          ['register_form-error_username_length'],
          'lengthRange',
          [{ key: 'minLength', val: 'min' }, { key: 'maxLength', val: 'max' }],
        ),
      ]);
    },
  },
  methods: {
    goBack(): void {
      this.confirmBeforeClose = true;
      this.showErrorMessage = false;
      this.tokenSent = false;
      this.formModel.passwordModel.token = '';
      this.loadingMessage = this.$options.filters.t([
        'global_finding-data',
        'global_loading',
      ]);
      this.errorMessage = this.params.errorMessage;
    },
    forgotUsername(): void {
      this.openForgotUsernameScreen();
    },
    submitFormUsername(): void {
      this.isLoading = true;

      // REST 093
      api
        .get(`${MEMBER_API_SUB_URLS.users}/forgot-password`, {
          params: {
            username: this.formModel.usernameModel.userName,
          },
        })
        .then(() => {
          this.confirmBeforeClose = false;
          this.isLoading = false;
          this.tokenSent = true;
        })
        .catch((error) => {
          this.confirmBeforeClose = false;
          this.isLoading = false;
          this.showErrorMessage = true;
        });
    },
    submitForm(): void {
      this.isLoading = true;
      this.loadingMessage = this.$options.filters.t(
        'personal-information_loading_updating-password',
      );

      // REST 094
      api
        .post(
          `${MEMBER_API_SUB_URLS.users}/forgot-password`,
          {
            password: this.formModel.passwordModel.password,
            secureToken: this.formModel.passwordModel.token,
          },
          {
            params: {
              username: this.formModel.usernameModel.userName,
            },
          },
        )
        .then(() => {
          this.confirmBeforeClose = false;
          this.isLoading = false;
          this.showSuccessMessage = true;

          // GTM Event - Forgot Password
          window.dataLayer.push({
            event: 'forgotPassword',
          });
        })
        .catch((error) => {
          if (error.status === 403) {
            this.errorMessage = this.params.errorMessageTokenInvalid;
          } else if (error.message === 'Password has previously been used') {
            this.errorMessage = this.params.errorMessagePasswordReused;
          } else if (error.message === 'Password cannot contain user ID, first name, or last name') {
            this.errorMessage = this.params.errorMessagePasswordName;
          } else if (error.message === 'Password cannot change more than once in 24 hours.') {
            this.errorMessage = this.params.errorMessagePasswordAge;
          }
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    PasswordValidationIcon,
  },
});
